
export enum StatusTarefaRoteiroExecutadoEnum {
  NaoIniciado = 'NaoIniciado',
  Iniciado = 'Iniciado',
  Finalizado = 'Finalizado',
  FinalizadoComJustificativa = 'FinalizadoComJustificativa',
  Pausado = 'Pausado',
}
